<template>
	<div class="nav-list">
		<template v-for="(item,index) in sidebarData">
			<el-submenu :key="index" v-if="(item.children && item.children.length>0 || item.front_type == 1)" :index="item.component_name?item.component_name:''">
				<template slot="title">
					<i class="iconfont" :class="item.front_icon"></i>
					<span slot="title">{{ item.front_name }}</span>
				</template>
				<template v-for="(child,childindex) in item.children">
					<sidebar-item :key="childindex" :sidebarData="[child]" v-if="child.children && child.children.length>0 || child.front_type != 1"></sidebar-item>
					<el-menu-item :key="childindex" :class="child.front_type==1?'mar':''" v-else @click="toPath(child)" :index="child.component_name?child.component_name:''">
						<span slot="title">{{ child.front_name }}</span>
					</el-menu-item>
				</template>
			</el-submenu>
			<router-link v-else :to="{name:item.component_name}" :key="item.component_name">
				<el-menu-item :index="item.component_name">
					<i class="iconfont" :class="item.front_icon"></i>
					<span slot="title">{{ item.front_name }}</span>
				</el-menu-item>
			</router-link>
		</template>
	</div>
</template>

<script>
	export default {
		name: "SidebarItem",
		props: ["sidebarData"],
		methods: {
			toPath(item) {
				this.$emit("toPath", item);
			}
		}
	};
</script>

<style scoped>
	a {
		text-decoration: none;
	}

	.el-menu-item i,
	.el-submenu__title i {
		color: #fff;
		margin-right: 5px;
	}

	.el-menu--collapse .pl25 {
		padding-left: 0;
	}

	.nav-list>>>.el-submenu__icon-arrow {
		right: 16px;
	}

	>>>.el-submenu__icon-arrow {
		margin-top: -5px;
	}

	>>>.el-submenu .el-menu-item,
	>>>.el-menu-item,
	.el-submenu__title {
		height: 40px;
		line-height: 40px;
	}

	>>>.el-submenu__title {
		height: 46px;
		line-height: 46px;
	}

	.mar {
		padding-left: 44px !important;
	}
</style>